// extracted by mini-css-extract-plugin
export default {"root":"login_page_root__CyLYw","login_container":"login_page_login_container__E32tH","logo_container":"login_page_logo_container__j+0fe"};